import { dispatch } from 'fistore';
import { logout as logoutAction } from 'fistore/auth/slice';

export const fiLogout = () => {
  dispatch(logoutAction());
};
